export const FEATURE_FLAGS = {
  GLOBAL_SEARCH: { state: true, queryKey: 'global_search' },
}
